window.SpottedSwaper = (function () {
  var instances = {};
  var SPLIDE_CSS = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
  var SPLIDE_JS = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

  function loadSplide(callback) {
    if (window.Splide) {
      callback();
      return;
    }
    if (window.__splideLoading) {
      window.__splideCallbacks.push(callback);
      return;
    }
    window.__splideLoading = true;
    window.__splideCallbacks = [callback];

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = SPLIDE_CSS;
    document.head.appendChild(link);

    var script = document.createElement('script');
    script.src = SPLIDE_JS;
    script.onload = function () {
      window.__splideCallbacks.forEach(function (cb) {
        cb();
      });
      window.__splideCallbacks = [];
    };
    document.head.appendChild(script);
  }

  function updateSlideScale(splide, root) {
    if (root.dataset.scaleEffect !== 'true') return;

    var slides = root.querySelectorAll('.splide__slide');
    slides.forEach(function (slide) {
      slide.classList.remove('is-spotted-adjacent');
    });

    var active = splide.Components.Slides.getAt(splide.index);
    if (!active) return;

    var prev = active.slide.previousElementSibling;
    var next = active.slide.nextElementSibling;

    if (prev) prev.classList.add('is-spotted-adjacent');
    if (next) next.classList.add('is-spotted-adjacent');
  }

  function init(domId) {
    var el = document.getElementById(domId);
    if (!el || instances[domId]) return;

    loadSplide(function () {
      if (instances[domId]) return;

      var perPageDesktop = parseFloat(el.dataset.perPageDesktop) || 3.5;
      var perPageTablet = parseFloat(el.dataset.perPageTablet) || 2.5;
      var perPageMobile = parseFloat(el.dataset.perPageMobile) || 1.5;
      var gapDesktop = (el.dataset.gapDesktop || 80) + 'px';
      var gapTablet = (el.dataset.gapTablet || 55) + 'px';
      var gapMobile = (el.dataset.gapMobile || 55) + 'px';
      var autoplay = el.dataset.autoplay === 'true';
      var interval = parseInt(el.dataset.interval, 10) || 3000;
      var loop = el.dataset.loop === 'true';

      var splide = new Splide(el, {
        type: loop ? 'loop' : 'slide',
        perPage: perPageDesktop,
        perMove: 1,
        focus: 'center',
        gap: gapDesktop,
        arrows: true,
        pagination: false,
        drag: true,
        autoplay: autoplay,
        interval: interval,
        pauseOnHover: true,
        pauseOnFocus: true,
        speed: 400,
        breakpoints: {
          1439: {
            gap: gapTablet,
            perPage: perPageTablet
          },
          767: {
            gap: gapMobile,
            perPage: perPageMobile
          }
        }
      });

      splide.on('mounted move moved resized updated refreshed', function () {
        updateSlideScale(splide, el);
      });

      splide.mount();
      instances[domId] = splide;
    });
  }

  function destroy(domId) {
    if (instances[domId]) {
      instances[domId].destroy(true);
      delete instances[domId];
    }
  }

  return { init: init, destroy: destroy };
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.spotted-swaper').forEach(function (el) {
    window.SpottedSwaper.init(el.id);
  });
});
